import {TruckTypesContext} from "../components/TruckTypesContext.js";
import {useContext, useMemo} from "react";

export const useTruckTypeOptions = () => {
    const truckTypesData = useContext(TruckTypesContext);

    return useMemo(() => {
        if (!truckTypesData?.truck_types) return [];

        return truckTypesData.truck_types.map((truck) => ({
            value: truck.id,
            label: truck.title,
           // image: truck.icon,
            description: truck.description,
        }));
    }, [truckTypesData]);
};

export const CARGO_INSURANCE = [
    { value: 6, label: "N/A" },
    { value: 1, label: "$0 - $499" },
    { value: 2, label: "$500 - $999" },
    { value: 3, label: "$1,000 - $1,999" },
    { value: 4, label: "$2,000 - $2,999" },
    { value: 5, label: "$3,000 - $5,000" },
];
export const ITEM_WEIGHT = [
    { value: "0-50 lb", label: "0-50 lb" },
    { value: "50-100 lb", label: "50-100 lb" },
    { value: "100-200 lb", label: "100-200 lb" },
    { value: "200-300 lb", label: "200-300 lb" },
    { value: "300-500 lb", label: "300-500 lb" },
]

export const ITEM_SIZE = [
    { value: "Small", label: "Small" },  /* (16"x12"x12")*/
    { value: "Medium", label: "Medium" },  /* (18"x18"x16")*/
    { value: "Large", label: "Large" },  /* (18"x18"x24")*/
    { value: "Extra Large", label: "Extra Large" },  /* (24"x18"x24")*/
];
